import React from 'react';
import Carousel from 'react-material-ui-carousel'
import InsCompLogos from '../../../components/svg/insCompLogos';

const insCompanies = ["bulins", "bulstrad", "groupama", "dallbogg", "dzi", "generali", 
                      "levins",  "ozkins", "euroins", "",  "uniqa"]


const AddPolicyCarousel = () => {

    const renderCompaniesLogos = () => {
        return insCompanies.map((company, i) =>  {
            const CompanyLogo = InsCompLogos[company] ? InsCompLogos[company]() : null;
            return ( <div className='show-standart' key={i+1}>{CompanyLogo}</div> )
          });
    }

    const renderCompaniesLogosM = () => {
        return insCompanies.map((company, i) =>  {
            const CompanyLogo = InsCompLogos[company] ? InsCompLogos[company]() : null;
            if (CompanyLogo) {
                return ( <div className='show-mobile' key={i+1}>{CompanyLogo}</div> )
            }
          });
    }

    const renderPage1 = () => {
        return (
            <div className="nuIns-item">
                <h6 style={{fontSize: '12px', marginBottom: '1rem'}}>СКЛЮЧЕНА С НЯКОЙ ОТ СЛЕДНИТЕ ЗАСТРАХОВАТЕЛИ</h6>
                <div className="nuIns-comp-logos">
                    {renderCompaniesLogos()}
                    {renderCompaniesLogosM()}
                </div>
            </div>
        )
    }

    const renderPage2 = () => {
        return (
            <div className="nuIns-item">
                <h6 style={{fontSize: '14px', margin: '.1rem 0 1.5rem 0'}}>САМО 2 СТЪПКИ</h6>
                <ol>
                    <li>Попълваш само <b>номер на МПС и номер на съществуваща полица</b></li>
                    <li>Създаваш профил, <b>за да виждаш полицата в последствие</b></li>
                </ol>
                <p><b>Ще получиш напомняне при изтичане на полицата и/или при плащане на вноска</b></p>
            </div>
        )
    }

    return (
        <div className="nuIns-carousel-container">
            <Carousel className="custom-slider" autoPlay={false} >
                {renderPage1()}
                {renderPage2()}
            </Carousel>
        </div>
    )

}

export default AddPolicyCarousel;